<template>
  <van-swipe :autoplay="autoplay" :class="[{'round-border': round}]" :stop-propagation='false'>
    <van-swipe-item v-for="(item, index) in items" :key="'image'+index" @click='() =>{goto(items[index].link)}' >
      <img alt :src="item.image" />
    </van-swipe-item>
  </van-swipe>
</template>

<script>
  import Vue from 'vue';
  import { Swipe, SwipeItem } from 'vant';

  Vue.use(Swipe);
  Vue.use(SwipeItem);
  export default {
    data() {
      return {
        autoplay:2000,
      };
    },
    props: {
      items: {
        type: Array,
        require: true,
      },
      round:{
        type:Boolean,
        default:false
      }
    },
  }
</script>

<style scoped>

.van-swipe img {
    display: block;
    box-sizing: border-box;
    width: 100%;
    /* height: 45vw; */
    background-color: #fff;
    pointer-events: none;
}
.van-swipe>>>.van-swipe__indicator {
   background: #bbb;
}
.van-swipe>>>.van-swipe__indicator--active {
  background: #fff
}
.round-border {
  border-radius: 10px;
}
.shadow {
  box-shadow: 0 0 5px 0 #eee;
}
</style>